import { FILES_ENDPOINT } from "Constants";
import { baseApi } from "Services";
import { SoftwareInfoUpdateRequest } from "../types";

const softwareInfoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateSoftwareInfo: builder.mutation<void, SoftwareInfoUpdateRequest>({
      query: (data) => ({
        url: `${FILES_ENDPOINT}/file/${data.id}/software-info/update`,
        method: "PATCH",
        body: data.softwareInfo,
      }),
      // no need to invalidate since update will be received through websockets
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateSoftwareInfoMutation } = softwareInfoApi;
